export const MAX_ATTEMPTS_CODE_REACHED = 'Превышено количество отправок кода подтверждения для данного номера телефона';
export const MAX_ATTEMPTS_REACHED = 'Превышено количество попыток, попробуйте позже. Блокировка на 15 минут';
